import data from '../features/fe-data/mock';

export default function () {
  this.get('/fe-data', () => [
    200,
    { 'Content-Type': 'application/json' },
    JSON.stringify(data)
  ]);
}
